import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const KineticLine = ({ children, delay = 0, load = false, className = "" }) => (
  <motion.span
    className={`block overflow-hidden ${className}`}
    initial="hidden"
    {...(load
      ? { animate: "visible" }
      : { whileInView: "visible", viewport: { once: true, amount: 0.4 } })}
    transition={{ duration: 1.1, delay, ease: EASE }}
  >
    <motion.span
      className="block will-change-transform"
      variants={{ hidden: { y: "112%" }, visible: { y: "0%" } }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export default function KineticText({ lines, delay = 0, load = false, className = "", lineClassName = "" }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <KineticLine key={i} delay={delay + i * 0.12} load={load} className={lineClassName}>
          {line}
        </KineticLine>
      ))}
    </span>
  );
}

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);
